import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Rodeo } from 'model/rodeo';
import { RodeoEvent } from 'model/rodeoEvent';

@Component({
    selector: 'event-select',
    templateUrl: 'event-select.html'
})
export class EventSelectPopup {
    rodeo: Rodeo;
    selectedRodeoEvent: RodeoEvent;

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.rodeo = navParams.get('rodeo');

        this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];
    }

    openEntry() {
        this.viewController.dismiss({ selectedRodeoEvent: this.selectedRodeoEvent });
    }

    cancel() {
        this.viewController.dismiss({});
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/entries/event-select.ts